import Vue, {VueConstructor} from 'vue'
import htmlMaker from './htmlMaker'
import './assets/styles.scss'

export default {
  install (Vue: VueConstructor, oprions: any) {
    Vue.filter('emoji', htmlMaker)
  }
}